import { render } from "./Editor.vue?vue&type=template&id=9e036b10"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=9e036b10&lang=css"

import exportComponent from "C:\\Users\\saidd\\OneDrive\\Desktop\\AKSA\\Projekti\\udruzenje pravobranilaca\\Admin\\vue-notus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__